"use client"

import { useEffect, useState } from "react"
import DatePicker, { registerLocale } from "react-datepicker"
import ContentHeader from "../../components/ContentHeader"
import Loader from "../../components/Loader"
import Swal from "sweetalert2"
import axios from "axios"
import "datatables.net-bs4"
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
import "select2"
import "select2/dist/css/select2.min.css"
import { Tooltip } from "bootstrap"
import "react-datepicker/dist/react-datepicker.css"
import es from "date-fns/locale/es"
import $ from "jquery"
import { jsPDF } from "jspdf"
import autoTable from "jspdf-autotable"
import { format } from "date-fns"
import { safeCurrencyFormat } from "../../utils/currencyFormatter"

const today = new Date()

// Función auxiliar para formatear números de forma segura
const safeNumberFormat = (value) => {
  if (value === null || value === undefined) return '0.00'
  const numericValue = parseFloat(value || '0')
  if (isNaN(numericValue)) return '0.00'
  return numericValue.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
registerLocale("es", es)

const totalSectionStyle = {
  background: "#033c73",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
}

const BranchBinnacleReport = () => {
  const [loading, setLoading] = useState(false)
  const [date, setDate] = useState(new Date())
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [userRol, setUserRol] = useState(null)
  const [binnacleData, setBinnacleData] = useState([])
  const [branches, setBranches] = useState([])
  const [selectedBranch, setSelectedBranch] = useState("0")
  const [totalBinnacleAmount, setTotalBinnacleAmount] = useState(0)
  const [totalPassengers, setTotalPassengers] = useState(0)
  const [totalFirst11, setTotalFirst11] = useState(0)
  const [totalAdmin, setTotalAdmin] = useState(0)
  const [totalRoadIncome, setTotalRoadIncome] = useState(0)
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT
  const TITLEALERT = process.env.REACT_APP_TITLE_ALERT

  const formatDate = (dateString, fieldType = "default") => {
    if (!dateString) return ""

    // Create a date object from the string
    const date = new Date(dateString)

    if (fieldType === "date_ticket") {
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    }

    // Format the date
    const day = date.getDate().toString().padStart(2, "0")
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }


  const handleOpenBinnacle = async (ticket) => {
      const form = new FormData();
      form.append('branch_id', ticket.branch_name); // Asegúrate de que este dato venga en dataTicket
      form.append('date', ticket.date); // Usa la fecha seleccionada (debe estar en formato 'YYYY-MM-DD')
      form.append('time', ticket.time);
      form.append('user_id', "1"); // Opcional, si es requerido por el backend
    
      try {
        const response = await axios.post(ENDPOINT + 'print-pdf-binnacle', form, {
          responseType: 'blob',
        });
    
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        window.open(url, '_blank');
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '<div class="title-custom-alert">Error</div>',
          html: '<div class="text-custom-alert">No se pudo generar la bitácora para este viaje.</div>',
        });
      }
    };


  const formatTime = (timeString) => {
    if (!timeString) return ""
    const [hours, minutes] = timeString.split(":")
    const date = new Date()
    date.setHours(hours)
    date.setMinutes(minutes)
    const formattedMinutes = date.getMinutes().toString().padStart(2, "0")
    const ampm = date.getHours() >= 12 ? "PM" : "AM"
    const hours12 = date.getHours() % 12 || 12
    const formattedHours12 = hours12.toString().padStart(2, "0")
    return `${formattedHours12}:${formattedMinutes} ${ampm}`
  }

  useEffect(() => {
    const storedUser = localStorage.getItem("dataUser")
    if (!storedUser) return

    const user = JSON.parse(storedUser)
    setUserRol(user.rol_id)
  }, [])

  const isAdmin = userRol === 1 || userRol === 2

  // useEffect para inicializar tooltips de Bootstrap
  useEffect(() => {
    setTimeout(() => {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl))
    }, 100)
  }, [])

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const branchesRes = await axios.get(ENDPOINT + "get-all-branchs-ticket")
        setBranches(branchesRes.data.data.map((b) => ({
          label: b.name,
          value: b.branch_id,
        })))
      } catch (error) {
        console.error("Error cargando sucursales:", error)
      }
    }

    if (isAdmin) {
      fetchBranches()
    }
  }, [isAdmin])

  const handleSearch = async () => {
    const form = new FormData()
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id
    
    form.append("user_id", user_id)
    
    if (isAdmin) {
      if (selectedBranch && selectedBranch !== "0") {
        form.append("branch_id", selectedBranch)
      }
      
      if (startDate instanceof Date && !isNaN(startDate)) {
        const year = startDate.getFullYear();
        const month = (startDate.getMonth() + 1).toString().padStart(2, "0");
        const day = startDate.getDate().toString().padStart(2, "0");
        form.append("startDate", `${year}-${month}-${day}`);
      } else {
        form.append("startDate", "");
      }
      
      if (endDate instanceof Date && !isNaN(endDate)) {
        const year = endDate.getFullYear();
        const month = (endDate.getMonth() + 1).toString().padStart(2, "0");
        const day = endDate.getDate().toString().padStart(2, "0");
        form.append("endDate", `${year}-${month}-${day}`);
      } else {
        form.append("endDate", "");
      }
    } else {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, "0")
      const day = date.getDate().toString().padStart(2, "0")
      const dateFormat = year + "-" + month + "-" + day
      form.append("date", dateFormat)
    }
    
    setLoading(true)
    await axios
      .post(ENDPOINT + "binnacle-branch-report", form)
      .then((response) => {
        setLoading(false)
        setBinnacleData(response.data.data.binnacles || [])
        setTotalBinnacleAmount(response.data.data.total_amount || 0)
        setTotalPassengers(response.data.data.total_passengers || 0)
        setTotalFirst11(response.data.data.total_first_11 || 0)
        setTotalAdmin(response.data.data.total_admin || 0)
        setTotalRoadIncome(response.data.data.total_road_income || 0)
      })
      .catch((error) => {
        setLoading(false)
        const errorMessage = error.response?.data?.msg ||
          error.response?.data?.message ||
          error.message ||
          'Error desconocido al procesar la solicitud';

        Swal.fire({
          icon: 'error',
          title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
          showConfirmButton: true,
          html: '<div class="text-custom-alert">' + errorMessage + '</div>',
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' }
        });
      })
  }

  const resetPage = () => {
    window.location.reload()
  }

  const handlePrint = async () => {
    setLoading(true)
    const form = new FormData()
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id
    form.append("user_id", user_id)
    
    if (isAdmin) {
      if (selectedBranch && selectedBranch !== "0") {
        form.append("branch_id", selectedBranch)
      }
      
      if (startDate instanceof Date && !isNaN(startDate)) {
        const year = startDate.getFullYear();
        const month = (startDate.getMonth() + 1).toString().padStart(2, "0");
        const day = startDate.getDate().toString().padStart(2, "0");
        form.append("startDate", `${year}-${month}-${day}`);
      }
      
      if (endDate instanceof Date && !isNaN(endDate)) {
        const year = endDate.getFullYear();
        const month = (endDate.getMonth() + 1).toString().padStart(2, "0");
        const day = endDate.getDate().toString().padStart(2, "0");
        form.append("endDate", `${year}-${month}-${day}`);
      }
    } else {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, "0")
      const day = date.getDate().toString().padStart(2, "0")
      const date_send = year + "-" + month + "-" + day
      form.append("date", date_send)
    }

    await axios
      .post(ENDPOINT + "export-binnacle-branch-report", form, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
        )
        const link = document.createElement("a")
        link.href = url
        const date_send = startDate && endDate 
          ? `${format(startDate, "dd-MM-yyyy")}_a_${format(endDate, "dd-MM-yyyy")}`
          : format(date, "dd-MM-yyyy")
        link.setAttribute("download", `reporte-bitacoras-sucursal-${date_send}.xlsx`)
        document.body.appendChild(link)
        link.click()
      })
      .catch((error) => {
        console.log(error)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html: '<div class="text-custom-alert">Error! No hay datos para descargar </div>',
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
    setLoading(false)
  }

  return (
    <div>
      {loading && <Loader />}
      <div className="container-fluid">
        <ContentHeader title="Módulo de Reportes" />
      </div>
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <div className="indications-header row">
              <div className="col-md-7">
                <h4 className="card-title m-0 page-title">
                  <i className="bi bi-journal-text me-2"></i> Reporte por Bitácora de Sucursal
                </h4>
              </div>
              <div className="col-md-5" style={{ textAlign: "right" }}>
                <button onClick={resetPage} className="btn btn-info btn-sm me-1" type="button">
                  <i className="fa fa-refresh me-1"></i> Recargar
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row g-4 mb-4">
              <div className="col-lg-7">
                <div className="search-controls bg-light p-4 rounded-3 shadow-sm h-100">
                  <div className="add-trips-card-body">
                    <div className="mb-4">
                      <h6 className="text-muted mb-3">
                        <i className="fas fa-info-circle me-2"></i>
                        Seleccione una fecha para visualizar el reporte de bitácoras por sucursal
                      </h6>
                    </div>
                    <div className="row align-items-end">
                      <div className="col-md-7 mb-3 mb-md-0">
                        {!isAdmin && (
                          <>
                            <label htmlFor="date" className="form-label fw-bold mb-2">
                              <i className="far fa-calendar-alt me-2"></i>
                              Fecha del Reporte
                            </label>
                            <div className="input-group">
                              <DatePicker
                                showIcon
                                locale="es"
                                selected={date}
                                onChange={(date) => setDate(date)}
                                className="form-control form-control-sm"
                                dateFormat="dd, MMMM, yyyy"
                                placeholderText={today.toLocaleDateString("es-ES", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric"
                                })}
                              />
                            </div>
                            <small className="text-muted mt-1 d-block">
                              La información corresponderá a la fecha seleccionada
                            </small>
                          </>
                        )}

                        {isAdmin && (
                          <div className="row mt-3">
                            {/* Fechas de inicio y fin */}
                            <div className="col-md-6 mb-3">
                              <label htmlFor="startDate" className="form-label fw-bold mb-2">
                                <i className="far fa-calendar-alt me-2"></i> Fecha Inicio
                              </label>
                              <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                className="form-control form-control-sm"
                                dateFormat="dd/MM/yyyy"
                                placeholderText={today.toLocaleDateString("es-ES", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric"
                                })}
                                locale="es"
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label htmlFor="endDate" className="form-label fw-bold mb-2">
                                <i className="far fa-calendar-alt me-2"></i> Fecha Fin
                              </label>
                              <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                className="form-control form-control-sm"
                                dateFormat="dd/MM/yyyy"
                                placeholderText={today.toLocaleDateString("es-ES", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric"
                                })}
                                locale="es"
                              />
                            </div>

                            {/* Filtros de Sucursal */}
                            <div className="col-md-12 mb-3">
                              <label htmlFor="branch" className="form-label fw-bold mb-2">
                                <i className="fas fa-building me-2"></i> Sucursal
                              </label>
                              <select
                                id="branch_id"
                                name="branch_id"
                                className="form-control form-control-sm select2 w-100"
                                value={selectedBranch}
                                onChange={(e) => setSelectedBranch(e.target.value)}
                              >
                                <option value="0">Todas las sucursales</option>
                                {branches.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                              <small className="text-muted mt-1 d-block">Filtrar por sucursal específica</small>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-5">
                        <div className="d-grid gap-2">
                          <button
                            onClick={() => handleSearch()}
                            className="btn btn-primary btn-sm d-flex align-items-center justify-content-center py-2"
                          >
                            <i className="fa fa-search me-2"></i> Buscar
                          </button>
                          <button
                            onClick={() => handlePrint()}
                            className="btn btn-success btn-sm d-flex align-items-center justify-content-center py-2"
                          >
                            <i className="fa-solid fa-file-excel me-2"></i> Exportar Excel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cash-cut-summary h-100 text-white p-4 rounded-3 shadow position-relative overflow-hidden">
                  <div className="position-relative z-1">
                    <h6 className="text-white-50 mb-3">Total de bitácoras</h6>
                    <h2 className="display-4 fw-bold mb-0">
                      ${safeNumberFormat(totalBinnacleAmount)}
                    </h2>
                    <p className="mb-0 mt-2 text-white-50">
                      Total de pasajeros: {totalPassengers}
                    </p>
                    <p className="mb-0 mt-2 text-white-50">
                      Primeros 11 (En Repaticion): ${safeNumberFormat(totalFirst11)}
                    </p>
                    <p className="mb-0 mt-2 text-white-50">
                      Boletos Administración: ${safeNumberFormat(totalAdmin)}
                    </p>
                    <p className="mb-0 mt-2 text-white-50">
                      Ingresos de Camino: ${safeNumberFormat(totalRoadIncome)}
                    </p>
                    <p className="mb-0 mt-2 text-white-50">
                      <i className="fas fa-calendar-day me-1"></i>
                      {isAdmin && startDate && endDate ? (
                        `Del ${formatDate(startDate.toISOString().split("T")[0], "date_ticket")} al ${formatDate(endDate.toISOString().split("T")[0], "date_ticket")}`
                      ) : (
                        date.toLocaleDateString("es-ES", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      )}
                    </p>
                  </div>
                  <div className="position-absolute bottom-0 end-0 p-4 opacity-25">
                    <i className="fas fa-file-alt" style={{ fontSize: "5rem" }}></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-file-alt me-2"></i>
                  Bitácoras por Sucursal
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro detallado de todas las bitácoras generadas en la sucursal seleccionada.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Bitácoras</small>
                <h4 className="m-0">
                  ${safeNumberFormat(totalBinnacleAmount)}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-file-alt me-2"></i> Bitácoras
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="4%" className="text-center">#</th>
                      <th width="7%" className="text-center">Fecha</th>
                      <th width="7%" className="text-center">Horario</th>
                      <th width="7%" className="text-center">Sucursal</th>
                      <th width="4%" className="text-center">Corrida</th>
                      <th width="7%" className="text-center">Unidad</th>
                      <th width="9%" className="text-center">Conductor</th>
                      <th width="4%" className="text-center">Pax</th>
                      <th width="9%" className="text-center">Primeros 11</th>
                      <th width="9%" className="text-center">Admin</th>
                      <th width="9%" className="text-center">Ingresos Camino</th>
                      <th width="10%" className="text-center">Total</th>
                      <th width="10%" className="text-center">Print</th>
                    </tr>
                  </thead>
                  {binnacleData && binnacleData.length > 0 ? (
                    <tbody>
                      {binnacleData.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.binnacle_id}</td>
                          <td className="text-center">{item.date}</td>
                          <td className="text-center">{item.time}</td>
                          <td className="text-center">{item.branch_name || 'N/A'}</td>
                          <td className="text-center">{item.corrida || 'N/A'}</td>
                          <td className="text-center">{item.unit_name || 'N/A'}</td>
                          <td className="text-center">{item.driver_name || 'N/A'}</td>
                          <td className="text-center">{item.passengers_count || 0}</td>
                          <td className="text-center">
                            ${safeNumberFormat(item.first_11_amount)}
                          </td>
                          <td className="text-center">
                            ${safeNumberFormat(item.admin_amount)}
                          </td>
                          <td className="text-center">
                            ${safeNumberFormat(item.road_income_amount)}
                          </td>
                          <td className="text-center">
                            ${safeNumberFormat(item.total_amount)}
                          </td>

                          <td className="text-center">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => handleOpenBinnacle(item)}
            title="Ver Bitácora de Viaje"
          >
            <i className="fas fa-file-pdf"></i> Bitácora
          </button>
        </td>

                        </tr>
                      ))}
                      <tr>
                        <td colSpan="7" className="text-end">
                          <strong>Pasajeros Transportados</strong>
                        </td>
                        <td className="text-center">
                          <strong>{totalPassengers}</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            ${safeNumberFormat(totalFirst11)}
                          </strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            ${safeNumberFormat(totalAdmin)}
                          </strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            ${safeNumberFormat(totalRoadIncome)}
                          </strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            ${safeNumberFormat(totalBinnacleAmount)}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="11" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BranchBinnacleReport